<template>
    <div class="form-box">
        <el-form
            class="form__center"
            label-width="72px"
            size="small"
        >
            <el-form-item
                label="手机号："
            >
                {{ encrypted }}
            </el-form-item>
            <el-form-item label="验证码：">
                <el-input
                    v-model="formItem.code"
                    placeholder="请输入手机验证码"
                    style="width: 200px;margin-right: 30px"
                />
                <el-button
                    type="text"
                    :disabled="showCount"
                    @click="sendCaptcha"
                >
                    <span v-show="!showCount">{{ text }}</span>
                    <span v-show="showCount">{{ count }}秒后重新发送</span>
                </el-button>
            </el-form-item>
            <el-form-item>
                <el-button
                    class="btn-standard"
                    type="primary"
                    @click="onSubmit"
                >
                    下一步
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import qs from 'qs'

export default {
    name: 'Step1',
    inject: ['goPage'],
    data () {
        return {
            formItem: {
                code: ''
            },
            userInfo: {},
            showCount: false,
            timer: null,
            count: 60,
            text: '发送验证码'
        }
    },
    computed: {
        encrypted () {
            let phone = this.userInfo.phone || ''
            return phone.substring(0, 3) + ' **** ' + phone.substring(phone.length - 4)
        },
        errors () {
            return this.$vuerify.$errors
        }
    },
    vuerify: {
        'formItem.code': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入手机验证码'
            },
            {
                test: /^\d{6}$/,
                message: '请输入6位数字验证码'
            }
        ]
    },
    mounted () {
        this.getUserInfo()
    },
    methods: {
        sendCaptcha () {
            this.$http.post('/api/sendsms', qs.stringify({
                phone: this.userInfo.phone,
                type: 5
            })).then(res => {
                if (res) {
                    if (res.data.send_status === 1) {
                        if (!this.timer) {
                            this.count = 60
                            this.showCount = true
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= 60) {
                                    this.count--
                                } else {
                                    this.showCount = false
                                    clearInterval(this.timer)
                                    this.timer = null
                                    this.text = '重新发送'
                                }
                            }, 1000)
                        }
                    }
                }
            })
        },
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/resetphone', qs.stringify({
                    step: 0,
                    code: this.formItem.code
                })).then(res => {
                    if (res.code === 0) {
                        this.goPage(`/index/info/phone/step2`)
                    } else {
                        this.$message.error(res.message)
                    }
                })
                    .catch(err => {
                        console.log(err)
                    })
            }
        },
        getUserInfo () {
            try {
                if (window.localStorage.getItem('USERINFO')) {
                    this.userInfo = JSON.parse(window.localStorage.getItem('USERINFO'))
                } else {
                    throw new Error('获取本地userInfo失败')
                }
            } catch (err) {
                this.$http.get('/api/user/userinfo')
                    .then(res => {
                        if (res.code === 0) {
                            this.userInfo = res.data
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .form__center {
        width: 402px;
    }
</style>
